export default function PrivacyContent() {


return <div>
	
	<div style={{textAlign:'center'}}>
		<h2>Terms of Use/Privacy Policy</h2>
	 </div>
	<div className="termsofuse" style={{textAlign:'left'}} >
		<br/>
		
		<ol>
			<li><span ><strong>Agreement to be bound</strong></span>
			<ol>
			<li><span >By using our service you agree to be bound by the terms of agreement, which may change from time to time</span></li>
			</ol>
			</li>
			<li><span ><strong>Privacy</strong></span>
				<ol>
				<li><span >This software does not store personal information. This website is not backed by a central database. All the information required by the application is stored on your device.</span></li>
				<li><span >You can delete all the information on your device at any time using the Settings page.</span></li>
				<li><span >The owners of this software do not know who or how many people are using the software.</span></li>
				<li><span >You can optionally use the software to store information on <i>Google Drive</i>. If you login, all changes to your tune book and any audio recordings are saved to <i>Google Drive</i>.</span></li>
				<li><span >If you use the software to share either your tune book or recordings, you are granting permission for any user (with a Google account) to read the shared file.</span></li>
				<li><span >If you choose to <i>Login With Google</i> to enable cloud storage and sharing, you are subject to the <a target="_new" href="https://www.google.com/drive/terms-of-service/">Terms and Conditions of Google Drive</a>.</span></li>
				
				</ol>
			</li>
			
			<li><span > <strong>Third-party login</strong></span>
			<ol>
			<li><span >This site relies entirely on Google to provide login and cloud storage. </span></li>
			<li><span >In using Google services you are subject to the <a target="_new" href="https://policies.google.com/privacy">Google Privacy Policy</a>  </span></li>
			</ol>
			</li>
			
			
	
			
			<li><span > <strong>Third-party content</strong></span>
				<ol>
				<li><span >This site assists users to collect content from third parties. This is not an endorsement of this material and we have no responsibility for any loss caused by reliance or access to third-party sites.</span></li>
				
				<li><span >Collected content only exists on your device (or your Google Drive) and can only be shared by explicit actions by you to download and send ABC files to another person by email or other electronic means.</span></li>
				
				<li><span >No collection of data from your device or tracking of any kind is part of this site with the exception of what is implemented through your use of Google Services. If you don't login, there is no tracking.</span></li>
				
				
				<li><span >When using the features to play YouTube videos, Search, Import and Export playlists from YouTube, you are subject to <a href="https://www.youtube.com/t/terms" target="_new" >YouTube's Terms of Service</a></span></li>
				
				<li><span >Other than what is shown when playing YouTube videos, there is no Advertising on this site.</span></li>
				
				</ol>
			</li>
			
			
			<li><span > <strong>User Conduct</strong></span>
			<ol>
			<li><span >You will not engage in conduct or contribute content that belongs to another party or is offensive, obscene, threatening, unlawful, defamatory, vilifying, inducing to violence, harassing, invasive of privacy, or discriminatory, solicitation or spam or private or confidential information or that jeopardises the operations of the site in any way or seek to gain unauthorised access to our servers or misuse the site to cause harm.</span></li>
			<li><span >We will endeavour to and reserve the right to remove content that breaches these terms as quickly as possible but we accept no liability for any harm suffered by exposure to or reliance on such content.</span></li>
			<li><span >We may preserve and disclose user content if required to do so by law.</span></li>
			</ol>
			</li>
			<li><span > <strong>Termination of Your Account</strong></span>
			<ol>
			<li><span >We may modify, suspend or delete your account and associated user content and block your access to the site if you breach these terms. </span></li>
			<li><span >You may request that your account be deleted at any time and we will comply in reasonable time.</span></li>
			<li><span >Termination of your account will not necessarily remove content you have contributed according to the terms in the preceding clause. </span></li>
			</ol>
			</li>
			
			<li><span ><strong>Intellectual property</strong></span>
			<ol>
			<li><span >The content on this site, including that contributed by users, is subject to a Creative Commons Licence (Attribution CC BY Version 4.0 (international licence)) (<a target="_new" href="http://creativecommons.org.au/learn/licences/">see here</a>). This means that 'whenever a work is copied or redistributed ... the original creator (and any other nominated parties) must be credited and the source linked to.' </span></li>

			<li><span >The software used on this site is open source and subject to GNU General Public License version 3 (<a href="https://opensource.org">see here</a>)</span></li>
			</ol>
			</li>
			
			<li><span > <strong>No Representations or Warranties</strong></span>
			<ol>
			<li><span >We do not guarantee that our services will always be available or free from bugs or viruses and the onus is on you to maintain current anti-virus software.</span></li>
			<li><span >We will endeavor to provide quality content, but make no guarantees to the ongoing quality or quantity of content, including premium content.</span></li>
			<li><span >We do not guarantee any warranties such as implied warranties of fitness for purpose or that this site will result in any improvement in your learning.</span></li>
			<li><span >We do not guarantee that the information on this site is accurate or up to date.</span></li>
			</ol>
			</li>
			<li><span > <strong>Limitation of Liability</strong></span>
			<ol>
			<li><span >Other than as required by law, we are not liable to you for any damages caused by use of or reliance on this site<br /></span></li>
			</ol>
			</li>
			<li><span > <strong>Indemnity</strong></span>
			<ol>
			<li><span >You agree to indemnify us from any loss or liability due to a claim brought by any third party arising from your user content or conduct.</span></li>
			</ol>
			</li>
			<li><span > <strong>Dispute resolution etc</strong></span>
			<ol>
			<li><span >These terms and the relationship between us and you are governed by the laws of Australia and subject to the exclusive jurisdiction of Australian courts, with the exception of injunctive relief in any jurisdiction in order to enforce our rights under these terms.</span></li>
			<li><span >If we fail to exercise or enforce any rights or provision of these terms, this does not constitute a waiver of such rights or provisions.</span></li>
			<li><span >If any provision of the terms are found by a court of competent jurisdiction to be invalid, the parties nevertheless agree that the court should endeavour to give effect to the parties' intentions as reflected in the provision, and the other provisions of the terms remain in full force and effect.</span></li>
			<li><span >You agree that these terms represent the entire understanding between us and you and these terms supersede any previous agreements, promises, assurances, warranties, representations and understandings, whether written or oral, between us and you.</span></li>
			</ol>
			</li>
		</ol>
				
	</div>
</div>
}
